import type {Code} from 'services/codelists/types';
import {CodeListRef} from 'schemas/references';

const validProductForm: Array<Code['code']> = [
  CodeListRef['PRODUCT_FORM']['Kart, uspesifisert'],
  CodeListRef['PRODUCT_FORM']['Kart, falset'],
  CodeListRef['PRODUCT_FORM']['Kart, plano'],
  CodeListRef['PRODUCT_FORM']['Kart, rullet'],
  CodeListRef['PRODUCT_FORM']['Annet kartografisk format'],
];

const validProductFormDetails: string =
  CodeListRef.PRODUCT_FORM_DETAIL['Vannavvisende / værbestandig'];

export const isKart = (
  code: Pick<Code, 'code'>,
  productForm: string,
): boolean => {
  return (
    validProductFormDetails === code.code &&
    validProductForm.includes(productForm)
  );
};
